import type { App } from "vue";
import { permissionDirective } from "@shared/directives/permission";

export function setupPermissionDirective(app: App) {
    app.directive("permission", permissionDirective);
}
